import { Box, CircularProgress, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { DefaultButton, MainButton, MainMultipleSelect, SuccessButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";

export default function ProjectShareModal({
    open,
    onClose,
    value,
    options,
    project,
    loading,
    onChange,
}) {
    const { mode } = useColorScheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[mode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        setSelectedOptions(value);
    }, [open, loading]);
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Typography id="modal-project-create-title" variant="h6" component="h2" fontWeight={"bold"}>
                    {`Share ${project?.name}`}
                </Typography>
                <Typography
                    sx={{
                        fontSize: Constants.Styles.fontSize.sm,
                        fontWeight: Constants.Styles.fontWeight.medium,
                        mt: "1.25rem",
                        mb: "1rem",
                    }}
                >
                    Add team members
                </Typography>
                {loading ? <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: { xs: "100%", sm: 400, }, }}>
                    <CircularProgress size={26} />
                </Box> : <Box
                    sx={{
                        width: { xs: "100%", sm: 400, },
                    }}
                >
                    <MainMultipleSelect
                        value={selectedOptions}
                        options={options}
                        onChange={(v) => {
                            typeof v === "string" ? setSelectedOptions(v.split(",")) : setSelectedOptions(v);
                        }}
                    />
                </Box>}
                <Stack direction={"row"} alignItems={"center"} justifyContent={"end"} spacing={2} sx={{
                    mt: "2rem",
                }}>
                    <DefaultButton
                        text={"Cancel"}
                        onClick={onClose}
                        size="small"
                    />
                    <SuccessButton
                        text={"Share Project"}
                        size="small"
                        disabled={loading || selectedOptions.length === 0}
                        onClick={() => {
                            onChange(selectedOptions);
                        }}
                    />
                </Stack>
            </Box>
        </Modal>
    );
}